class Tooltip {
  tooltip: HTMLElement;
  showTooltipEvent: string;
  hideTooltipEvent: string;

  constructor(tooltip: HTMLElement, tooltipName: string) {
    this.tooltip = tooltip;
    this.showTooltipEvent = `show${tooltipName}`;
    this.hideTooltipEvent = `hide${tooltipName}`;

    window.addEventListener(this.showTooltipEvent, () => this.handleShowTooltip());
    window.addEventListener(this.hideTooltipEvent, () => this.handleCloseTooltip());
    this.addCloseEvent();
  }

  get isTooltipShowing() {
    return this.tooltip?.style.display !== 'none';
  }

  handleShowTooltip() {
    if (!this.tooltip) return;

    this.tooltip.style.removeProperty('display');
  }

  handleCloseTooltip() {
    if (!this.tooltip) return;

    this.tooltip.setAttribute('style', 'display:none');
  }

  addCloseEvent() {
    if (!this.tooltip) return;

    const button = this.tooltip.querySelector('.arjo-a-button');

    if (!button) return;

    button.addEventListener('click', () => {
      this.dispatchHideTooltipEvent();
    });
  }

  dispatchShowTooltipEvent() {
    window.dispatchEvent(
      new CustomEvent(this.showTooltipEvent),
    );
  }

  dispatchHideTooltipEvent() {
    window.dispatchEvent(
      new CustomEvent(this.hideTooltipEvent),
    );
  }
}

export { Tooltip };
